<template>
    <div>
        <div id="ag-grid-demo">
            <vx-card class="p-4 mb-6">
                <div class="flex flex-wrap items-center justify-between mb-10">
                    <div class="flex items-center">
                        <h4 style="margin-left: 10px">Wave Pick Planning</h4>
                    </div>
                    <div class="flex items-center">
                        <vs-button @click="fetch()" class="btn mb-4 md:mb-0 mr-1" icon="refresh">Refresh</vs-button>
                        <vs-button class="btn mb-4 md:mb-0 mr-1" icon="filter_list" @click="filterInit">Filter</vs-button>
                        <vs-button class="btn mb-4 md:mb-0 mr-1" icon="remove_red_eye" :disabled="disableView" @click="view">View</vs-button>
                        <vs-button class="btn mb-4 md:mb-0 mr-1" icon="add" :to="{ name: 'wave-pick-planning-add'}" >New Wavepick</vs-button>
                    </div>
                </div>
                <ag-grid-vue
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="data"
                    colResizeDefault="shift"
                    :animateRows="false"
                    :floatingFilter="false"
                    rowSelection="single"
                    :rowHeight="35"
                    :headerHeight="35"
                    @selectionChanged="disableView = false"
                    @rowDoubleClicked="view"
                >
                </ag-grid-vue>
                <p class="text-right"><strong>Showing {{ from }} to {{ to }} of {{ total }} total entries</strong></p>
                <vs-pagination :total="pages" v-model="current" :max="7"></vs-pagination>
                <vs-prompt @accept="fetch" title="Filter" :active.sync="showFilter">
            <div class="con-exemple-prompt">
                
                <label class="vs-input--label">Client</label>
                <vs-select
                    class="selectExample mb-2"
                    v-model="filter.client_id"
                    width="100%"
                    autocomplete
                    @input-change="searchDropdown($event, ddl_client)"
                >
                    <vs-select-item v-for="(item, index) in ddl_client.data" :key="index" :value="item.id" :text="item.client_code"/>
                </vs-select>
                <label class="vs-input--label">Status</label>
                <vs-select
                    class="selectExample"
                    v-model="filter.status_id"
                    width="100%"
                    autocomplete
                >
                    <vs-select-item v-for="(item, index) in status" :key="index" :value="item.id" :text="item.name"/>
                </vs-select>
            </div>
        </vs-prompt>
                
            </vx-card>
        </div>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { VueContext } from 'vue-context';

export default {
    components: {
        vSelect,
        AgGridVue,
        flatPickr,
        VueContext
    },
    data() {
        return {
            data: [],
            current: 1,
            from: 0,
            to: 0,
            total: 0,
            pages: 1,
            disableView: true,
            gridOptions: {},
            gridApi: null,
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            isLoading: false,
            showFilter: false,
            filter: {
                fetchCount: 0,
                client_id: null,
                status_id: null
            },
            ddl_client: {
                data: [],
                loading: false,
                endpoint: 'master/clients',
                objectKey: 'client_code'
            },
            uploadData: {
                file: null,
                order_source: 'none',
                client_id: null
                
            },
            status: [],
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        },
        current: function() {
            this.fetch()
        }
    },
    methods: {
        filterInit() {
            if(this.filter.fetchCount < 1) {
                this.isLoading = true
                this.fetchDropdowns()
                .then(() => {
                    this.isLoading = false
                    this.showFilter = true
                    this.filter.fetchCount++
                })
                .catch(() => {
                    this.isLoading = false
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.filterInit();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                })
            }
            else {
                this.showFilter = true
            }
        },
        fetchDropdowns() {
            return Promise.all([
                this.$http.post("/master/clients"),
                this.$http.get("/outbound/outboundstatus"),
            ]).then(
                this.$http.spread((clients, status) => {
                    this.ddl_client.data = clients.data.data;
                    this.status = status.data
                    this.status.unshift({
                        id: null,
                        name: 'Any'
                    })

                    this.ddl_client.data.unshift({
                        id: null,
                        client_code: 'Any'
                    })
                })
            );
        },
        refreshData() {
            this.fetch()
        },
        fetch() {
            this.isLoading = true;
            this.setFilter(this.filter);
            //Promise.all([this.$http.post('wavepick/list', this.filter), this.$http.post('unlock_all')])
            return this.$http.post(`wavepick/list?page=${this.current}`, this.filter)
            .then(res => {
                this.data = res.data.data;
                this.total = res.data.total;
                this.to = res.data.to || 0;
                this.from = res.data.from || 0;
                this.pages = res.data.last_page;
                this.isLoading = false;
            })
            .catch(() => {
                this.isLoading = false
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: 'Server Error',
                    text: 'Try again?',
                    accept: () => {
                        this.refreshData()
                    },
                    acceptText: 'Yes',
                    cancelText: 'No'
                });
                return;
            });
        },
        view() {
            const id = this.getSelectedId();

            this.$router.push({
                name: 'wave-pick-planning-view',
                params: {
                    id: id
                }
            });
        },
        getSelectedId() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = '';
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ', ';
                }

                selectedRowsString += selectedRow.id;
            });

            return selectedRowsString;
        }
    },
    mounted() {
        Promise.all([
            this.fetch('order')
        ])
        .then(() => this.isLoading = false);
        this.gridApi = this.gridOptions.api
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: 'ID',
                field: 'id',
                width: 120,
            },
            {
                headerName: 'Reference',
                field: 'reference',
                width: 120,
            },
            {
                headerName: 'Date',
                field: 'date',
                width: 120,
            },
            {
                headerName: 'Client ID',
                field: 'client_code',
                width: 120,
            },
            {
                headerName: 'Warehouse ID',
                field: 'warehouse_code',
                width: 120,
            },
            {
                headerName: 'Total Volume',
                field: 'total_volume',
                width: 120,
            },
            {
                headerName: 'Total Weight',
                field: 'total_weight',
                width: 120,
            },
            {
                headerName: 'Total Quantity',
                field: 'total_quantity',
                width: 120,
            },
            {
                headerName: 'Total Order',
                field: 'total_order',
                width: 120,
            },
            {
                headerName: 'Picking Line',
                field: 'picking_line',
                width: 120,
            },
        ];
    }
}

</script>